import { useState, useEffect, Fragment } from 'react';
import axios from '../../axios/axiosconf';
import Header from '../general/Header';
import Aside from '../general/Aside';
import Footer from '../general/Footer';
import Unauthorized from '../general/Unauthorized';
import Loading from '../general/Loading';
import { Link } from 'react-router-dom';

function ReporteFacturasRecibos() {
    // Estados de autenticación y permisos
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(null);
    const [client, setClient] = useState({});

    // Estados de datos
    const [facturas, setFacturas] = useState([]);
    const [totales, setTotales] = useState({
        total_facturas: 0,
        total_facturado: 0,
        total_cobrado: 0,
        total_pendiente: 0
    });

    // Estados de filtros
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [pacienteFiltro, setPacienteFiltro] = useState('');
    const [estadoFiltro, setEstadoFiltro] = useState('');
    const [pacientes, setPacientes] = useState([]);

    // Estados de paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const [totalPaginas, setTotalPaginas] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);

    // Estado de expansión
    const [facturaExpandida, setFacturaExpandida] = useState(null);

    // Estado de carga
    const [loading, setLoading] = useState(false);

    // Obtener fecha de hace 30 días
    const getFechaHace30Dias = () => {
        const fecha = new Date();
        fecha.setDate(fecha.getDate() - 30);
        return fecha.toISOString().split('T')[0];
    };

    // Obtener fecha actual
    const getFechaActual = () => {
        return new Date().toISOString().split('T')[0];
    };

    useEffect(() => {
        let userdata = {};

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // Validación de permisos híbrida
        let tienePermiso = false;

        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission =>
                permission.slug === 'ver_reporte_facturas_recibos'
            );
        } else if (userdata.up && userdata.up.includes('ver_reporte_facturas_recibos')) {
            tienePermiso = true;
        }

        setHasPermission(tienePermiso);

        if (!tienePermiso) {
            return;
        }

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.error('Error al cargar cliente:', error);
            });

        // Cargar pacientes para el filtro
        axios.get('/pacientes?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setPacientes(response.data);
                }
            })
            .catch(error => {
                console.error('Error al cargar pacientes:', error);
            });

        // Establecer fechas por defecto (último mes)
        setFechaInicio(getFechaHace30Dias());
        setFechaFin(getFechaActual());

    }, []);

    // Cargar facturas cuando cambian los filtros o la página
    useEffect(() => {
        if (loggedIn && hasPermission && fechaInicio && fechaFin) {
            cargarFacturas();
        }
    }, [loggedIn, hasPermission, paginaActual]);

    const cargarFacturas = () => {
        setLoading(true);

        let userdata = {};
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const params = {
            uid: userdata.user_id,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin,
            page: paginaActual,
            per_page: 12
        };

        if (pacienteFiltro) {
            params.paciente_id = pacienteFiltro;
        }

        if (estadoFiltro === 'contado') {
            params.tipo_pago = 'contado';
        } else if (estadoFiltro === 'credito') {
            params.tipo_pago = 'credito';
        } else if (estadoFiltro !== '') {
            params.estado = estadoFiltro;
        }

        axios.get('/reportes/facturas-recibos', { params })
            .then(response => {
                if (response.status === 200) {
                    setFacturas(response.data.facturas || []);
                    setTotales(response.data.totales || {
                        total_facturas: 0,
                        total_facturado: 0,
                        total_cobrado: 0,
                        total_pendiente: 0
                    });
                    setTotalPaginas(response.data.total_paginas || 1);
                    setTotalRegistros(response.data.total_registros || 0);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar facturas:', error);
                setLoading(false);
            });
    };

    const handleBuscar = (e) => {
        e.preventDefault();
        setPaginaActual(1);
        cargarFacturas();
    };

    const handleLimpiar = () => {
        setFechaInicio(getFechaHace30Dias());
        setFechaFin(getFechaActual());
        setPacienteFiltro('');
        setEstadoFiltro('');
        setPaginaActual(1);
    };

    const handleExportarExcel = () => {
        let userdata = {};
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const params = new URLSearchParams({
            uid: userdata.user_id,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin
        });

        if (pacienteFiltro) {
            params.append('paciente_id', pacienteFiltro);
        }

        if (estadoFiltro === 'contado') {
            params.append('tipo_pago', 'contado');
        } else if (estadoFiltro === 'credito') {
            params.append('tipo_pago', 'credito');
        } else if (estadoFiltro !== '') {
            params.append('estado', estadoFiltro);
        }

        // Abrir en nueva ventana para descargar
        window.open(`${axios.defaults.baseURL}/reportes/facturas-recibos/exportar-excel?${params.toString()}`, '_blank');
    };

    const toggleFactura = (facturaId) => {
        if (facturaExpandida === facturaId) {
            setFacturaExpandida(null);
        } else {
            setFacturaExpandida(facturaId);
        }
    };

    const formatearMoneda = (valor) => {
        return '$' + Number(valor).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const soloFecha = String(fecha).slice(0, 10);
        const partes = soloFecha.split('-');
        if (partes.length !== 3) return fecha;
        return `${partes[2]}/${partes[1]}/${partes[0]}`;
    };

    const getBadgeEstado = (estado) => {
        switch (estado) {
            case 1:
            case 4:
                return 'report-chip report-chip--ok';
            case 2:
            case 5:
                return 'report-chip report-chip--warn';
            case 3:
            case 6:
                return 'report-chip report-chip--bad';
            case 7:
            case 0:
            default:
                return 'report-chip report-chip--neutral';
        }
    };

    // Mismo estilo "pill suave" usado en ListadoFacturas.js
    const getEstadoBadgeStyle = (estado) => {
        switch (parseInt(estado, 10)) {
            case 7: // Borrador RIPS
                return { background: 'rgba(23, 162, 184, 0.08)', color: '#17a2b8', border: '1px solid rgba(23, 162, 184, 0.22)', borderRadius: '999px', fontSize: '0.67rem', padding: '4px 8px', fontWeight: 700 };
            case 1: // Cobrada / contado
            case 4:
                return { background: 'rgba(40, 167, 69, 0.08)', color: '#28a745', border: '1px solid rgba(40, 167, 69, 0.22)', borderRadius: '999px', fontSize: '0.67rem', padding: '4px 8px', fontWeight: 700 };
            case 2: // Por cobrar / crédito
            case 5:
                return { background: 'rgba(250, 173, 20, 0.10)', color: '#faad14', border: '1px solid rgba(250, 173, 20, 0.22)', borderRadius: '999px', fontSize: '0.67rem', padding: '4px 8px', fontWeight: 700 };
            case 3: // Anulada
            case 6: // Error DIAN
                return { background: 'rgba(220, 53, 69, 0.08)', color: '#dc3545', border: '1px solid rgba(220, 53, 69, 0.22)', borderRadius: '999px', fontSize: '0.67rem', padding: '4px 8px', fontWeight: 700 };
            case 0: // Generada
            default:
                return { background: 'rgba(108, 117, 125, 0.08)', color: '#6c757d', border: '1px solid rgba(108, 117, 125, 0.22)', borderRadius: '999px', fontSize: '0.67rem', padding: '4px 8px', fontWeight: 700 };
        }
    };

    const getReciboBadgeStyle = (estado) => {
        if (parseInt(estado, 10) === 1) {
            return { background: 'rgba(40, 167, 69, 0.08)', color: '#28a745', border: '1px solid rgba(40, 167, 69, 0.22)', borderRadius: '999px', fontSize: '0.67rem', padding: '4px 8px', fontWeight: 700 };
        }
        return { background: 'rgba(220, 53, 69, 0.08)', color: '#dc3545', border: '1px solid rgba(220, 53, 69, 0.22)', borderRadius: '999px', fontSize: '0.67rem', padding: '4px 8px', fontWeight: 700 };
    };

    // Protección de ruta
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn || hasPermission === null) {
        return <Loading />;
    }

    return (
        <div className="hold-transition" style={{ fontSize: '13px' }}>
            <Header client={client} />
            <Aside client={client} activelink="reports" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/estadisticas">Reportes</Link></li>
                                    <li className="breadcrumb-item"><Link to="/estadisticas-contables">Contables</Link></li>
                                    <li className="breadcrumb-item active">Facturas vs Recibos</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <h1 className="m-0">
                                    <i className="fas fa-file-invoice-dollar mr-2"></i>
                                    Reporte Facturas vs Recibos
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">

                        {/* Filtros */}
                        <div className="card report-fin-card">
                            <div className="card-header">
                                <h3 className="card-title">
                                    <i className="fas fa-filter mr-2"></i>
                                    Filtros
                                </h3>
                                <div className="card-tools">
                                    <button
                                        type="button"
                                        className="btn btn-outline-success btn-sm"
                                        onClick={handleExportarExcel}
                                        disabled={loading || facturas.length === 0}
                                        title="Exportar a Excel"
                                    >
                                        <i className="fas fa-file-excel mr-1"></i>
                                        Exportar Excel
                                    </button>
                                </div>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleBuscar}>
                                    <div className="row">
                                        <div className="col-md-2 col-lg-2">
                                            <div className="form-group">
                                                <label>Fecha Inicio</label>
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm"
                                                    value={fechaInicio}
                                                    onChange={(e) => setFechaInicio(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2 col-lg-2">
                                            <div className="form-group">
                                                <label>Fecha Fin</label>
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm"
                                                    value={fechaFin}
                                                    onChange={(e) => setFechaFin(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2 col-lg-2">
                                            <div className="form-group">
                                                <label>Paciente (Opcional)</label>
                                                <select
                                                    className="form-control form-control-sm"
                                                    value={pacienteFiltro}
                                                    onChange={(e) => setPacienteFiltro(e.target.value)}
                                                >
                                                    <option value="">Todos</option>
                                                    {pacientes.map(paciente => (
                                                        <option key={paciente.id} value={paciente.id}>
                                                            {paciente.primer_nombre} {paciente.primer_apellido}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2 col-lg-2">
                                            <div className="form-group">
                                                <label>Estado (Opcional)</label>
                                                <select
                                                    className="form-control form-control-sm"
                                                    value={estadoFiltro}
                                                    onChange={(e) => setEstadoFiltro(e.target.value)}
                                                >
                                                    <option value="">Todos</option>
                                                    <option value="contado">Contado</option>
                                                    <option value="credito">Crédito</option>
                                                    <option value="pendientes_envio">Pendiente envío</option>
                                                    <option value="pendientes_pago">Pendiente pago</option>
                                                    <option value="contabilidad">Contabilidad</option>
                                                    <option value="3">Anuladas</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-lg-4">
                                            <div className="form-group">
                                                <label>&nbsp;</label>
                                                <div className="d-flex flex-nowrap align-items-center" style={{ gap: '6px' }}>
                                                    <button type="submit" className="btn btn-primary btn-sm px-2" disabled={loading}>
                                                        <i className="fas fa-search mr-1"></i>
                                                        Buscar
                                                    </button>
                                                    <button type="button" className="btn btn-secondary btn-sm px-2" onClick={handleLimpiar} disabled={loading}>
                                                        <i className="fas fa-eraser mr-1"></i>
                                                        Limpiar
                                                    </button>
                                                    <Link to="/estadisticas-contables" className="btn btn-outline-secondary btn-sm px-2">
                                                        <i className="fas fa-arrow-left mr-1"></i>
                                                        Volver
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* Cards de Totales */}
                        <div className="row">
                            <div className="col-md-3">
                                <div className="card card-outline card-secondary">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h3 className="mb-0">{totales.total_facturas}</h3>
                                                <p className="text-muted mb-0">Total Facturas</p>
                                            </div>
                                            <div className="report-fin-kpi-icon" style={{ background: 'rgba(108, 117, 125, 0.12)', color: '#6c757d' }}>
                                                <i className="fas fa-file-invoice"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card card-outline card-secondary">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h3 className="mb-0">{formatearMoneda(totales.total_facturado)}</h3>
                                                <p className="text-muted mb-0">Total Facturado</p>
                                            </div>
                                            <div className="report-fin-kpi-icon" style={{ background: 'rgba(23, 162, 184, 0.12)', color: '#17a2b8' }}>
                                                <i className="fas fa-dollar-sign"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card card-outline card-success">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h3 className="mb-0">{formatearMoneda(totales.total_cobrado)}</h3>
                                                <p className="text-muted mb-0">Total Pagados</p>
                                            </div>
                                            <div className="report-fin-kpi-icon" style={{ background: 'rgba(40, 167, 69, 0.10)', color: '#28a745' }}>
                                                <i className="fas fa-check-circle"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card card-outline card-warning">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h3 className="mb-0">{formatearMoneda(totales.total_pendiente)}</h3>
                                                <p className="text-muted mb-0">Total Por Cobrar</p>
                                            </div>
                                            <div className="report-fin-kpi-icon" style={{ background: 'rgba(255, 193, 7, 0.12)', color: '#d39e00' }}>
                                                <i className="fas fa-clock"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Tabla de Facturas */}
                        <div className="card report-fin-card">
                            <div className="card-header">
                                <h3 className="card-title">
                                    <i className="fas fa-list mr-2"></i>
                                    Facturas ({totalRegistros})
                                </h3>
                            </div>
                            <div className="card-body p-0">
                                {loading ? (
                                    <div className="text-center py-5">
                                        <i className="fas fa-spinner fa-spin fa-3x text-primary"></i>
                                        <p className="mt-3 text-muted small">Cargando facturas...</p>
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-hover mb-0 report-fin-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '44px' }}></th>
                                                    <th>N° Factura</th>
                                                    <th>Fecha</th>
                                                    <th>Paciente</th>
                                                    <th className="text-right">Total</th>
                                                    <th className="text-right">Pagado</th>
                                                    <th className="text-right">Pendiente</th>
                                                    <th>Estado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {facturas.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="8" className="text-center py-4">
                                                            <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                                                            <p className="text-muted">No se encontraron facturas para el período seleccionado</p>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    facturas.map((item) => (
                                                        <Fragment key={item.factura.id}>
                                                            <tr
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => toggleFactura(item.factura.id)}
                                                            >
                                                                <td className="text-center">
                                                                    <i className={`fas fa-chevron-${facturaExpandida === item.factura.id ? 'down' : 'right'}`}></i>
                                                                </td>
                                                                <td><strong>{item.factura.numero_completo}</strong></td>
                                                                <td>{formatearFecha(item.factura.fecha_emision)}</td>
                                                                <td>{item.factura.paciente_nombre}</td>
                                                                <td className="text-right">{formatearMoneda(item.factura.valor_total)}</td>
                                                                <td className="text-right text-success">{formatearMoneda(item.factura.valor_pagado)}</td>
                                                                <td className="text-right text">{formatearMoneda(item.factura.saldo_pendiente)}</td>
                                                                <td>
                                                                    <span
                                                                        className={`badge ${getBadgeEstado(item.factura.estado)}`}
                                                                        style={getEstadoBadgeStyle(item.factura.estado)}
                                                                    >
                                                                        {item.factura.estado_texto}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            {facturaExpandida === item.factura.id && item.recibos.length > 0 && (
                                                                <tr>
                                                                    <td colSpan="8" className="bg-light">
                                                                        <div className="p-3">
                                                                            <h6 className="mb-3 small font-weight-bold text-secondary">
                                                                                <i className="fas fa-receipt mr-2"></i>
                                                                                Recibos de caja ({item.recibos.length})
                                                                            </h6>
                                                                            <table className="table table-sm table-bordered mb-0">
                                                                                <thead className="bg-white">
                                                                                    <tr>
                                                                                        <th>N° Recibo</th>
                                                                                        <th>Fecha Pago</th>
                                                                                        <th className="text-right">Valor</th>
                                                                                        <th>Forma Pago</th>
                                                                                        <th>Estado</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {item.recibos.map((recibo) => (
                                                                                        <tr key={recibo.id}>
                                                                                            <td>{recibo.numero_recibo}</td>
                                                                                            <td>{formatearFecha(recibo.fecha_pago)}</td>
                                                                                            <td className="text-right">{formatearMoneda(recibo.valor_pago)}</td>
                                                                                            <td>{recibo.forma_pago_texto}</td>
                                                                                            <td>
                                                                                                <span className={`report-chip ${recibo.estado === 1 ? 'report-chip--ok' : 'report-chip--bad'}`} style={getReciboBadgeStyle(recibo.estado)}>
                                                                                                    {recibo.estado_texto}
                                                                                                </span>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                            {facturaExpandida === item.factura.id && item.recibos.length === 0 && (
                                                                <tr>
                                                                    <td colSpan="8" className="bg-light">
                                                                        <div className="p-3 text-center text-muted">
                                                                            <i className="fas fa-info-circle mr-2"></i>
                                                                            No hay recibos de caja registrados para esta factura
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </Fragment>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                            {totalPaginas > 1 && (
                                <div className="card-footer clearfix">
                                    <ul className="pagination pagination-sm m-0 float-right">
                                        <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setPaginaActual(paginaActual - 1)}
                                                disabled={paginaActual === 1}
                                            >
                                                «
                                            </button>
                                        </li>
                                        {[...Array(totalPaginas)].map((_, i) => (
                                            <li key={i} className={`page-item ${paginaActual === i + 1 ? 'active' : ''}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => setPaginaActual(i + 1)}
                                                >
                                                    {i + 1}
                                                </button>
                                            </li>
                                        ))}
                                        <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setPaginaActual(paginaActual + 1)}
                                                disabled={paginaActual === totalPaginas}
                                            >
                                                »
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>

                    </div>
                </section>
            </div>

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default ReporteFacturasRecibos;
